import {createContext, type ReactNode, use, useMemo, useState} from 'react'

interface CodeNavContextType {
  validCodeNav: boolean
  setValidCodeNav: (valid: boolean) => void
}

const CodeNavContext = createContext<CodeNavContextType | null>(null)

export function CodeNavProvider({children}: {children: ReactNode}) {
  const [validCodeNav, setValidCodeNav] = useState(true)

  const value = useMemo(() => ({validCodeNav, setValidCodeNav}), [validCodeNav])

  return <CodeNavContext value={value}>{children}</CodeNavContext>
}

export function useCodeNav() {
  const context = use(CodeNavContext)
  if (!context) {
    throw new Error('useCodeNav must be used within a CodeNavProvider')
  }
  return context
}
